import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import NonComplianceTable from './table/NonComplianceTable'
import NonCompliancesLoader from './_load/NonCompliancesLoader'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const NonComplianceListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listNonCompliance">
        <Container>
          <FilterHandler tempStorageNamespace="nonCompliance" initialState={{ fixedFilterFields: ['statuses'] }}>
            <PageHeader />
            <ControlBar />
            <MultiSelectHandler>
              <NonCompliancesLoader uncontrolledChildren={<MultiRowsActions />}>
                <NonComplianceTable />
              </NonCompliancesLoader>
            </MultiSelectHandler>
          </FilterHandler>
          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default NonComplianceListPage
